<template>
  <div v-if="!showFetchLocationModal">
    <div class="botm-bar-wrap" v-if="showBottomBarNav">
      <!-- promo-offer-nudges -->
      <div>
        <div
          class="promo-offer-bar color-green-offer"
          :class="[isOfferSelected ? 'promo-offer-bar-active' : '']"
          v-if="isOnHomePage && appliedOfferPromo && welcomeOffers.length"
        >
          <div class="d-flex align-items-center">
            <img :src="staticImgBaseUrl + '/images/global/percentStar.svg'" />
            <div class="d-flex">
              <span class="fs-12 pl8 fw-700">
                {{ appliedOfferPromo }} Applied!
              </span>
              <span class="fs-12 pl4">{{ appliedOfferDescription }}</span>
            </div>
          </div>
          <div @click="triggerOfferDetailsModal">
            <i
              aria-hidden="true"
              class="hkfi-arrow-line fs-12 tr color-success fw-700"
            ></i>
          </div>
        </div>
      </div>
      <div class="bottom-nav-home border-top box-shadow1">
        <div
          class="flex-row justify-content-between p4"
          v-for="(item, index) in visibleResults"
          :key="index"
        >
          <div
            @click="handleIconClick(item.link_rewrite)"
            class="align-items-center flex-column"
            v-if="item.title !== 'View Cart'"
            v-ripple="item.title === 'View Cart'"
          >
            <span class="bb-ico-holder">
              <VueLottiePlayer
                name="confettiAnim"
                :animationData="
                  require(`../assets/BottomBarLottie/${item.title}.json`)
                "
                width="100%"
                height="100%"
                v-if="item.title === activeTab"
              />
              <img
                :src="getIcon(item)"
                alt="icon image"
                class="icon-bottom-bar"
                v-else
              />
              <span
                v-if="isShowCount(item.attributes) && offersList.length"
                class="circular-holder"
                >{{ offersList.length }}</span
              >
            </span>
            <span
              class="fs-11"
              :class="[
                item.title === activeTab ? 'color-slaty' : 'color-grey-light',
              ]"
            >
              {{ item.title }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom bar for cart in search page -->
    <div
      class="bottom-nav-focused plr16"
      :class="{ active: cartQuantity > 0 }"
      v-if="isSearchPage && cartQuantity > 0"
    >
      <span class="nav-item" @click="handleCartClick($event)" v-ripple>
        <div
          v-if="cartQuantity >= 0"
          class="btn btn-checkout disp-col-inline secondary"
        >
          <span class="mr3">
            <transition name="slide-fade" mode="out-in">
              <span :key="cartQuantity">
                {{ this.cartQuantity }}
                {{ this.cartQuantity > 1 ? "items" : "item" }}</span
              >
            </transition>
            <i aria-hidden="true" class="jfi-cart fs-18"></i>
          </span>
          <div class="d-flex align-items-center pr4">
            <span class="bold ml4 mr8 fs-14">View Cart</span>
            <i aria-hidden="true" class="hkfi-arrow-line fs-10 bold"></i>
          </div>
        </div>
      </span>
    </div>

    <notify-toast-message />
  </div>
</template>

<script>
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import {
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_VIEWCART,
  EVENT_CLICK_BOTTOM_STICKY_BAR,
} from "../helpers/analyticsEvents";
import { defineAsyncComponent } from "vue";
import NotifyToastMessage from "./NotifyToastMessage.vue";

export default {
  name: "BottomBarHome",
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    NotifyToastMessage,
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      staticImgBaseUrl,
      selectedPromoIndex: -1,
      parsedResults: [],
      selectedLottie: "",
    };
  },
  mounted() {
    this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
  },
  methods: {
    isShowCount(attrs) {
      const attributesArray = JSON.parse(`[${attrs}]`);
      const showCountAttribute = attributesArray.find(
        (attribute) => attribute.key === "showCount",
      );
      if (this.isOnOffersPage) return false;
      return showCountAttribute ? showCountAttribute.value : null;
    },
    handleCartClick() {
      EVENT_CLICK_VIEWCART();
      LocalStorageFunc.setEmptyCartRedirection(location.href);
      LocalStorageFunc.setOffersFromTab(false);
      Utility.sendToCartScreen();
    },
    handleIconClick(linkRewrite) {
      if (linkRewrite === "/menu") {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 1,
          subcategory: "Menu",
        });
        let url =
          projectBasePathWithFolder +
          "/menu/" +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
        LocalStorageFunc.setOffersFromTab(false);
        url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
        window.location.href = url;
      } else if (linkRewrite === "/offers") {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 2,
          subcategory: "Offers",
        });
        LocalStorageFunc.setOffersFromTab(true);
        Utility.sendToOffersScreen();
      } else if (linkRewrite === "/store") {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 2,
          subcategory: "Home",
        });
        LocalStorageFunc.setOffersFromTab(false);
        Utility.redirectToHomeOrRedirectUrl();
      } else {
        EVENT_CLICK_BOTTOM_STICKY_BAR({
          positionWithinSection: 2,
          subcategory: linkRewrite,
        });
        LocalStorageFunc.setOffersFromTab(false);
      }
    },
    hideCartTotal() {
      return true;
    },
    getIcon(item) {
      let icon = "";
      if (item.title === this.activeTab) {
        const attributesArray = JSON.parse(`[${item.attributes}]`);
        attributesArray.forEach((attribute) => {
          if (attribute.key === "selectedIcon") {
            icon = attribute.value;
          }
        });
        return icon;
      } else {
        return item.icon;
      }
    },
    triggerOfferDetailsModal() {
      document.body.classList.add("body-stop-scroll-mobile");

      this.$store.commit(keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG, true);

      this.appliedOfferPromo &&
        this.$store.state.Offers.offersList?.map((i, index) => {
          if (i.couponCode == this.appliedOfferPromo) {
            this.selectedPromoIndex = index;
            this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
              campaignId: i.campaignId,
            });
          }
        });

      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
        this.selectedPromoIndex,
      );

      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_FROM_BOTTOM_BAR,
        true,
      );
    },
  },
  computed: {
    appliedOfferDescription() {
      return this.$store.state.Offers.offersList.length
        ? this.$store.state.Offers.offersList?.find(
            (x) => x.couponCode == this.appliedOfferPromo,
          )?.metaData?.shortSavingsMessage
        : "";
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    visibleResults() {
      if (this.cartQuantity === 0) {
        return this.parsedResults.filter((x) => x.title != "View Cart");
      }
      return this.parsedResults;
    },
    activeTab() {
      if (this.isOnOffersPage) {
        return "Offers";
      } else if (this.isOnMenuPage) {
        return "Menu";
      } else {
        return "Home";
      }
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    isOfferSelected() {
      return LocalStorageFunc.getCouponCode()?.code !== undefined
        ? true
        : false;
    },
    isSearchPage() {
      return this.$store.state.ProductItems.showSearchModal;
    },
    isNotificationVisible() {
      return this.$store.state.Notification.notificationVisibilityStatus;
    },
    getNotificationPosition() {
      return this.$store.state.Notification.notificationPosition;
    },
    getPositionClass() {
      if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom-big"
      ) {
        return "move-up-inline-cart-big active";
      } else if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom"
      ) {
        return "move-up-inline-cart active";
      } else if (this.cartQuantity > 0) {
        return "active";
      }
      return "";
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    offersList() {
      return this.$store.state.Offers.offersList;
    },
    isOnOffersPage() {
      return Utility.isCurrentlyAtUrl("/offers");
    },
    isOnMenuPage() {
      return Utility.isCurrentlyAtUrl("/menu");
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    showBottomBarNav() {
      return (
        (!this.isSearchPage && !this.isOnOffersPage) ||
        LocalStorageFunc.getOffersFromTab()
      );
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    showFetchLocationModal() {
      return this.isOnHomePage
        ? this.$store.state.Location.showFetchLocationModal
        : false;
    },
  },
};
</script>
